<template>
  <div>
    <ImgCell v-for="(img, index) in imgs1" :src="img" :key="'1-' + index" :containerClass="`img-cell-${index}`" />
    <ImgTabs :tabs="applicationScenarioInfo" />
    <ImgCell v-for="(img, index) in imgs2" :src="img" :key="'2-' + index" />
    <Swipper :title="law.title" :imgs="law.imgs" />
    <ImgCell src="https://asset.esign.cn/apps/esign-landing/images/new_info.png" />
    <BottomForm
      :showManMachineSlide="!showForm"
      @msg="handleShowMsg"
      @submitSuccess="showSuccessDialog = true"
      :landingPageName="landingPageName"
    />
    <Footer />
    <BottomBtn title="立即申请 免费体验" @click="handleShow" :landingPageName="landingPageName" />
    <span v-if="isIOS && isUC">
      <CoverForm :show="showForm" @close="handleClose" @msg="handleShowMsg" @submitSuccess="handleDialogFormSuccess" />
    </span>
    <span v-else>
      <Form
        :show="showForm"
        @close="handleClose"
        @msg="handleShowMsg"
        @submitSuccess="handleDialogFormSuccess"
        :landingPageName="landingPageName"
      />
    </span>
    <Message :content="message.content" :show.sync="message.show" />
    <DialogSuccess :show.sync="showSuccessDialog" @touchmove.native.stop.prevent />
  </div>
</template>

<script>
import pageMixin from './pageMixin.js'

export default {
  mixins: [pageMixin],
  components: {
    BottomBtn: () => import('./components/h5/BottomBtn.vue'),
    BottomForm: () => import('./components/h5/BottomForm.vue'),
    DialogSuccess: () => import('./components/h5/DialogSuccess.vue'),
    Footer: () => import('./components/h5/Footer.vue'),
    Form: () => import('./components/h5/Form.vue'),
    CoverForm: () => import('./components/h5/CoverForm.vue'),
    ImgCell: () => import('./components/h5/ImgCell.vue'),
    ImgTabs: () => import('./components/h5/ImgTabs.vue'),
    Message: () => import('./components/h5/Message.vue'),
    Swipper: () => import('./components/h5/Swipper.vue'),
  },
  data() {
    return {
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
      showForm: false,
      imgs1: [
        require('@/assets/images/H5banner.png'),
        // 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/h5_new_banner.gif',
        'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/2.png',
        'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/3.jpg',
        'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/4.jpg',
      ],
      imgs2: [
        'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/8_new.jpg',
        'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/7_new.jpg',
        'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/9_new.jpg',
      ],
      law: {
        title: 'e签宝电子签名合法合规',
        imgs: [
          'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/swiper_1.png?v=01',
          'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/swiper_2.png?v=01',
          'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/swiper_3.png?v=01',
        ],
      },
      applicationScenarioInfo: [
        {
          title: '企业内部人力资源应用',
          items: [
            {
              text: '劳动合同新签、续签',
              img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/con2_bg1.png',
            },
            {
              text: '竞业协议/保密协议',
              img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/con2_bg2.png',
            },
            {
              text: '期权授予协议',
              img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/con2_bg3.png',
            },
            {
              text: '各类人力资源证明材料',
              img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/humanResources/con2_bg4.png',
            },
          ],
        },
        {
          title: 'B2B电商平台',
          items: [
            {
              text: '商家入驻协议',
              img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/con1_bg1.png',
            },
            {
              text: '采购/销售协议',
              img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/con1_bg2.png',
            },
            {
              text: '报价单',
              img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/con1_bg3.png',
            },
            {
              text: '供应链融资协议',
              img: 'https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/con1_bg4.png',
            },
          ],
        },
      ],
      message: {
        content: '',
        show: false,
      },
      showSuccessDialog: false,
      isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      isUC: navigator.userAgent.indexOf('UCBrowser') > -1,
    }
  },
  mounted() {
    // 判断是否是ios
    if (this.isIOS && this.isUC) {
      document.body.addEventListener('focusin', () => {
        if (this.showForm) {
          document.getElementsByClassName('cover-div')[0].style.position = 'absolute'
        }
        // 软键盘弹起事件
        document.getElementsByClassName('btn_bottom')[0].style.position = 'absolute'
        document.getElementsByClassName('btn_bottom')[0].style.bottom = 'auto'
      })
      document.body.addEventListener('focusout', () => {
        if (this.showForm) {
          window.scrollTo(0, 0)
        }
        document.getElementsByClassName('btn_bottom')[0].style.position = 'fixed'
        document.getElementsByClassName('btn_bottom')[0].style.bottom = '0'
      })
    }
  },
  methods: {
    handleShowMsg({ content }) {
      this.message.content = content
      this.message.show = true
    },
    handleDialogFormSuccess() {
      this.handleClose()
      this.showSuccessDialog = true
    },
    handleShow() {
      this.showForm = true
      if (this.isIOS && this.isUC) {
        document.addEventListener('touchmove', this.touchStart, { passive: false })
      }
    },
    handleClose() {
      this.showForm = false
      if (this.isIOS && this.isUC) {
        document.removeEventListener('touchmove', this.touchStart, { passive: false })
      }
    },
    touchStart(event) {
      event.preventDefault() // 通知 Web 浏览器不要执行与事件关联的默认动作
    },
  },
}
</script>

<style lang="less">
* > img {
  max-width: 100%;
}

a {
  font-size: 1rem;
  color: #333;
}

a:hover,
input.error {
  color: #fa465a;
}

.container {
  width: 1200px\9;
}

@media (min-width: 1200px) {
  .main {
    min-width: 1200px;
  }
}

.banner,
.banner video,
.banner .text,
.banner .text .banner_tabbox .tab_listbox,
.con,
.con1,
.con1 .con1_tab .tab_box,
.con2,
.con2 .con2_tab .tab_box,
.con3,
.con4,
.con6,
.footer {
  min-width: 1200px;
}

.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}

.con1_h5 {
  width: 100%;
  background: #ececec;

  .con1_btw_bg {
    background: #fff;
    border-radius: 29px 29px 0 0;
  }
}

.img-cell-1 {
  background-color: #ececec;

  img {
    border-radius: 29px 29px 0px 0px;
  }
}
</style>
